import { Component, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Subscription, Observable } from "rxjs";
import { ClientModel } from "src/app/core/models/members/client/client.model";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { TimelineModel} from "src/app/core/models/timeline/timeline.model";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { TimeLineListService } from "src/app/core/services/list-services/time-line-list.service";
import { MyfileApiService } from "src/app/core/services/myfile-api.service";
import { LoginType } from "src/app/core/models/members/user/user-context.model";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { OpenModalService } from "src/app/core/services/modal-services/open-modal.service";
import { PdfViewerModalService } from "src/app/core/services/modal-services/pdf-viewer-modal.service";
import { ToasterNotificationService } from "src/app/core/services/toaster-notification.service";
import { TimeLineListSortBy } from "src/app/core/enums/sort-by-options/time-line-list-sort-enum";
import { Roles } from "src/app/core/security/roles";
import { OwnerEntityType } from "src/app/core/enums/owner-entity-type-enum";
import { TimeLineType } from "src/app/core/enums/timeline-type-enum";
import { TimelineNoteModalService } from "src/app/core/services/modal-services/timeline-note-modal.service";
import { ListLayoutExtendableComponent } from "../list-layout/list-layout-extendable/list-layout-extendable.component";
import { ListFilterModel } from "src/app/core/models/table/list-filter.model";
import { TableActionsModel } from "src/app/core/models/table/table-action.model";

@Component({
  selector: 'app-time-line-list',
  templateUrl: './time-line-list.component.html',
  styleUrls: ['./time-line-list.component.scss'],
  providers: [TimeLineListService]

})
export class TimeLineListComponent extends ListLayoutExtendableComponent {

  override rowActionSelected(rowAction: TableActionsModel): void {}
  override buttonActionSelected(buttonAction: any): void {}
  override filterSelected(filterSelected: ListFilterModel): void {}

  timelineTypeAvailableOptions = [
    { value: undefined, selectedText: $localize`:@@:Select Status`, default: true},
    { value: TimeLineType.Note, selectedText: $localize`:@@:Note` },
    { value: TimeLineType.Email, selectedText: $localize`:@@:Email` },
    { value:  TimeLineType.Event, selectedText: $localize`:@@:Event` },
  ]

  timelineOwnerEntityTypeAvailableOptions = [
    { value: undefined, selectedText: $localize`:@@:Select Type`, default: true},
    { value: OwnerEntityType.Client, selectedText: $localize`:@@:Client` },
    { value: OwnerEntityType.Contact, selectedText: $localize`:@@:Contact` },
    { value:  OwnerEntityType.Requisition, selectedText: $localize`:@@:Requisition` },
  ]

  sortBy: TimeLineListSortBy = TimeLineListSortBy.None;

  protected override searchPlaceHolderText: string = "Search for customer number, name, last name, or email";

  override listItemsObservable!: Observable<TimelineModel[]>;

  model: TimelineModel = new TimelineModel();

  OwnerEntityTypeArray: OwnerEntityType[] = [];
  loginType?: LoginType = this.authMyFileService.currentUserContextValue?.loginType;

  timelineTypeSelectedOption?: TimeLineType = undefined; 
  timelineOwnerEntityTypeSelectedOption?: OwnerEntityType = undefined; 

  securityPermissionTimelineCreateNote: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.timeLine.timeLineCreateNote);
  securityPermissionTimelineCreateEmail: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.timeLine.timeLineCreateEmail);
  securityPermissionTimelineManagement: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.timeLine.timeLineManagement);
  securityPermissionTimelineTimeLineRead: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.timeLine.timeLineRead);
  securityPermissionTimelineReadAll: boolean = this.authMyFileService.isInRole(Roles.admin);

  enumOwnerType = OwnerEntityType; 

  @Input() public timelineOwnerId?: string = undefined;
  @Input() public timelineClientId?: string = undefined;
  @Input() public ownerType?: OwnerEntityType  = undefined;
  @Input() public createdByUser?: boolean = false;

  constructor(
    protected TimelineNoteModalService: TimelineNoteModalService,
    protected timeLineListService: TimeLineListService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override openModalService: OpenModalService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  ngOnInit(): void {

    //If Admin allows the ability to see notes on User accounts by adding the USer Option to the drop down list. 
    if(this.securityPermissionTimelineReadAll){
      this.timelineOwnerEntityTypeAvailableOptions.push( { value: OwnerEntityType.User, selectedText: $localize`:@@:User` });
    }

    this.listItemsObservable = this.timeLineListService.resultItems$;
    this.total = this.timeLineListService.total$;
    this.isLoading = this.timeLineListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.isLoadingVal = true;
      } else {
        this.isLoadingVal = false;
      }
    });
    this.unsubscribe.push(subscr);

    this.timeLineListService.ownerId = this.timelineOwnerId;

    if (this.createdByUser) {
      this.timeLineListService.createdById = this.authMyFileService.currentUserContextValue?.id;
    }

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((timelineModel: TimelineModel) => {
        if (timelineModel.clientBase && timelineModel.clientBase.id && timelineModel.clientBase.profilePhotoFileId) {
          this.getEntityPhoto(timelineModel.clientBase, EntityTypeEnum.Client);
        }
        if (timelineModel.owner && timelineModel.owner.id && timelineModel.owner.profilePhotoFileId) {
          this.getEntityPhoto(timelineModel.owner, EntityTypeEnum.User);
        }
      });
    });
    this.unsubscribe.push(subscr2);
  }

  override ngOnDestroy(): void {
    this.clearSearch(this.timeLineListService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  timeLineOwnerEntityTypeFilter(event: any) {
    if(event.value!==undefined){
      this.timeLineListService.ownerEntityType = event.value;
    }else{
      this.timeLineListService.ownerEntityType = undefined;
    }
  }

  timeLineTypeFilter(event: any) {
    if(event.value !==undefined){
      this.timeLineListService.types = [event.value];
    }else{
      this.timeLineListService.types = undefined;
    }
  }

  openNote(timeLine: TimelineModel, disableModel: boolean) {
    if (timeLine.ownerEntityType == OwnerEntityType.Client) {
      this.myFileApiService.getClient(timeLine.ownerId!).subscribe((client: ClientModel | undefined) => {
        this.TimelineNoteModalService.openModal(timeLine,disableModel, OwnerEntityType.Client, client);
        var sub: Subscription = this.TimelineNoteModalService.modelChanged.subscribe((result: any) => {
          if (result) {
            this.model = new TimelineModel;
          }
          sub.unsubscribe();
        })
      })
    } else if (timeLine.ownerEntityType == OwnerEntityType.Requisition) {
      if (timeLine.type == TimeLineType.Note) {
        this.TimelineNoteModalService.openModal(timeLine,disableModel, OwnerEntityType.Requisition);
      } else {
        this.TimelineNoteModalService.openModal(timeLine,disableModel);
      }

      var sub: Subscription = this.TimelineNoteModalService.modelChanged.subscribe((result: any) => {
        if (result) {
          this.timeLineListService.startIndex = this.timeLineListService.startIndex;
          this.model = new TimelineModel;
        }
        sub.unsubscribe();
      });
    } else {
      this.TimelineNoteModalService.openModal(timeLine,disableModel);
      var sub: Subscription = this.TimelineNoteModalService.modelChanged.subscribe((result: any) => {
        if (result) {
          this.timeLineListService.startIndex = this.timeLineListService.startIndex;
          this.model = new TimelineModel;
        }
        sub.unsubscribe();
      })
    } 
  }


  renameDataType(type: TimeLineType): string {
    switch (type) {
      case TimeLineType.Note:
        return "Note"
      case TimeLineType.Event:
        return "Event"
      case TimeLineType.Email:
        return "Email"
      default:
        return `${type}`
    }
  }

  renameDataTimeSpent(time: number): string {
    var timeMin: any = time % 60;
    var timeHours = (time - timeMin) / 60;
    if (timeMin < 10) {
      timeMin = `0${timeMin}`
    }
    return `${timeHours}:${timeMin}`
  }

  sort(passedTimeLineListSortBy: TimeLineListSortBy) {
    this.sortBy = passedTimeLineListSortBy;
    switch (passedTimeLineListSortBy) {

      case TimeLineListSortBy.ClientNameAsc:
        this.serviceSort(this.timeLineListService, 'name', 'asc');
        break;

      case TimeLineListSortBy.ClientNameDesc:
        this.serviceSort(this.timeLineListService, 'name', 'desc');
        break;

      case TimeLineListSortBy.TimeSpentAsc:
        this.serviceSort(this.timeLineListService, 'timeSpent', 'asc');
        break;

      case TimeLineListSortBy.TimeSpentDesc:
        this.serviceSort(this.timeLineListService, 'timeSpent', 'desc');
        break;

      case TimeLineListSortBy.TypeAsc:
        this.serviceSort(this.timeLineListService, 'type', 'asc');
        break;

      case TimeLineListSortBy.TypeDesc:
        this.serviceSort(this.timeLineListService, 'type', 'desc');
        break;
      case TimeLineListSortBy.CreatedAsc:
        this.serviceSort(this.timeLineListService, 'createdDate', 'asc');
        break;
      case TimeLineListSortBy.CreatedDesc:
        this.serviceSort(this.timeLineListService, 'createdDate', 'desc');
        break;

      default:
        this.serviceSort(this.timeLineListService, '', '');
        break;
    }
  }

  openClientModal(modelId: string){
    this.openModalService.editClientModal(this.timeLineListService, modelId, this.timeLineListService.sortColumn, this.timeLineListService.sortDirection);
  }

}
